import { useQuery } from '@tanstack/react-query';

import { queries } from '../common/api/queryKeys/queries';

export const useCustomerIdList = ({ groupId, enabled = true }) => {
    return useQuery({
        ...queries.customers.list({ groupId }),
        select: (data) => data.map((customer) => customer.id),
        enabled,
    });
};
